import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { getMoviesByIds, featuredIds } from "@/mocks/movies";

export default function HeroCarousel() {
  const slides = getMoviesByIds(featuredIds).filter((m) => m.backdrop);
  const [active, setActive] = useState(0);

  useEffect(() => {
    if (slides.length <= 1) return undefined;
    const timer = setInterval(() => {
      setActive((prev) => (prev + 1) % slides.length);
    }, 6000);
    return () => clearInterval(timer);
  }, [slides.length]);

  if (slides.length === 0) return null;

  return (
    <section className="relative w-full overflow-hidden bg-primary-950">
      <div className="relative h-[520px] w-full md:h-[640px]">
        {slides.map((movie, index) => (
          <div
            key={movie.id}
            className={`absolute inset-0 transition-opacity duration-1000 ${
              index === active ? "opacity-100" : "opacity-0"
            }`}
          >
            <img
              src={movie.backdrop}
              alt={`${movie.title} 剧照`}
              title={`${movie.title} 80年代经典电影`}
              className={`h-full w-full object-top ${
                index === active ? "animate-slow-zoom" : ""
              }`}
            />
            <div className="absolute inset-0 bg-gradient-to-r from-primary-950/90 via-primary-950/60 to-primary-950/20"></div>
            <div className="absolute inset-0 bg-gradient-to-t from-primary-950/90 via-transparent to-transparent"></div>
          </div>
        ))}

        <div className="relative z-10 flex h-full w-full items-end">
          <div className="mx-auto w-full max-w-6xl px-4 pb-12 md:px-6 md:pb-16">
            <div key={slides[active].id} className="max-w-2xl animate-fade-up">
              <span className="inline-flex items-center gap-2 rounded-full bg-accent-500 px-3 py-1 font-label text-xs font-semibold text-background-50">
                <i className="ri-fire-fill"></i>
                本周焦点推荐
              </span>
              <h2 className="mt-4 font-heading text-3xl font-black leading-tight text-background-50 md:text-5xl">
                {slides[active].title}
              </h2>
              <p className="mt-2 font-label text-sm text-background-200 md:text-base">
                {slides[active].originalTitle} · {slides[active].year} ·{" "}
                {slides[active].genres.join(" / ")}
              </p>
              <p className="mt-4 max-w-xl font-label text-sm leading-relaxed text-background-100/90 line-clamp-2 md:text-base">
                {slides[active].summary}
              </p>
              <div className="mt-6 flex flex-wrap gap-3">
                <Link
                  to={`/detail/${slides[active].id}`}
                  className="inline-flex items-center gap-2 whitespace-nowrap rounded-md bg-accent-500 px-5 py-2.5 font-label text-sm font-semibold text-background-50 transition-colors hover:bg-accent-600"
                >
                  <i className="ri-play-circle-line text-lg"></i>
                  查看影片详情
                </Link>
                <Link
                  to="/category"
                  className="inline-flex items-center gap-2 whitespace-nowrap rounded-md border border-background-100/40 px-5 py-2.5 font-label text-sm font-semibold text-background-50 transition-colors hover:bg-background-50/10"
                >
                  浏览全部电影
                  <i className="ri-arrow-right-line"></i>
                </Link>
              </div>
            </div>

            <div className="mt-8 flex items-center gap-2">
              {slides.map((movie, index) => (
                <button
                  key={movie.id}
                  type="button"
                  onClick={() => setActive(index)}
                  aria-label={`切换到 ${movie.title}`}
                  className={`h-1.5 rounded-full transition-all duration-300 ${
                    index === active
                      ? "w-8 bg-accent-500"
                      : "w-4 bg-background-100/50 hover:bg-background-100/80"
                  }`}
                />
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}